export default "__VITE_ASSET__b70zHry2__"